var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckforplan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C5.883 0 0.5 5.383 0.5 12C0.5 18.617 5.883 24 12.5 24C19.117 24 24.5 18.617 24.5 12C24.5 5.383 19.117 0 12.5 0ZM18.7 10.512L14.274 14.857C13.491 15.625 12.483 16.008 11.474 16.008C10.476 16.008 9.478 15.632 8.698 14.879L6.799 13.012C6.405 12.625 6.4 11.992 6.787 11.598C7.173 11.203 7.808 11.198 8.201 11.586L10.094 13.447C10.87 14.197 12.095 14.193 12.875 13.429L17.3 9.085C17.693 8.697 18.324 8.704 18.714 9.098C19.101 9.492 19.095 10.125 18.7 10.512Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckforplan);
export default __webpack_public_path__ + "static/media/checkforplan.a39a0f4a926744d5c4be99f20110ffd4.svg";
export { ForwardRef as ReactComponent };